import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import TaskUpdation from "./taskUpdation";

const THEME = {
    primary: "#3b82f6",
};

class TaskUpdateModal extends Component {
    render() {
        const { show, handleClose, rowData, type } = this.props;

        return (
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                centered
                backdrop="static"
            >
                <Modal.Header
                    closeButton
                    style={{
                        background: THEME.primary,
                        color: "white",
                        borderBottom: "none",
                        borderRadius: "0.375rem 0.375rem 0 0",
                    }}
                >
                    <Modal.Title style={{ fontSize: "1.2rem", fontWeight: "600" }}>
                        Lead Update & History
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <TaskUpdation
                        rowData={rowData}
                        show={show}
                        handleClose={handleClose}
                        updationType={type}
                    />
                </Modal.Body>
            </Modal>
        );
    }
}

export default TaskUpdateModal;
